




import { Component, Vue } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import NewslettersAPI from "@/services/newsletters";
import RecordForm from "./Components/NewsletterForm.vue";
import Newsletter from "@/models/newsletter";

@Component({
  components: { RecordForm },
})
export default class NewNewsletter extends Vue {
  async save(model: Newsletter): Promise<void> {
    LayoutModule.showLoader();
    try {
      const r = await NewslettersAPI.new(model);
      LayoutModule.setAlerts({
        text: this.$t("newsletters.responses.success_create").toString(),
        type: "success",
      });
      this.$router.push({
        name: "editNewsletter",
        params: { id: r?.id as string },
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "newsletters" });
  }
}
